<template>
  <router-view />
</template>

<style>
@import "./assets/common/css/bootstrap.min.css";
</style>
